<template>
  <div class="page-main">
    <div class="recharge-content">
      <div
        :class="['recharge-item', currentSelectPayId == item.price_id ? 'active' : '']"
        v-for="(item, index) in rechargeList"
        :key="index"
        @click="selectRechargeAmount(item.credit_num, item.price_id)"
      >
        <div class="diamonds">
          <SvgIcon type="diamond" class="icon-18 icon-diamonds"></SvgIcon>
          <div>{{ item.credit_num }}</div>
        </div>
        <div class="money">{{ `${item.currency_mark}${item.default_price / 100}` }}</div>
      </div>
    </div>
    <div class="btn-list">
      <slot name="btn"></slot>
      <button class="btn-blue btn-exam" @click="payMoney()">
        {{ `${$t("test_pay")}  ${computedCompany}${computedAmount}` }}
      </button>
    </div>
  </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
import { apiRequest } from "@/serves/http";
// import { USE_S$_COUNTRY_LIST } from "@/config/index.js";

export default {
  name: "MuiRecharge",
  components: {
    SvgIcon,
  },
  data() {
    return {
      currentSelectPayId: "",
      currentSelectPayNum: "",
      rechargeList: [],
      moneyType: "usd",
    };
  },
  props: {
    // 用户差额
    difference: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    computedAmount() {
      return (
        this.currentSelectPayId &&
        this.rechargeList?.find((item) => item.price_id == this.currentSelectPayId)?.default_price / 100
      );
    },
    computedCompany() {
      return this.rechargeList?.find((item) => item.price_id == this.currentSelectPayId)?.currency_mark || "";
    },
  },
  async created() {
    await this.getMoneyType();
    await this.getProductList();
  },
  methods: {
    // 选择充值金额
    selectRechargeAmount(num, id) {
      this.currentSelectPayId = id;
      this.currentSelectPayNum = num;
    },
    // 获取币种类型
    getMoneyType() {
      return new Promise((resolve, reject) => {
        try {
          apiRequest.get(window.ApiPath.pay_person_money_type).then((res) => {
            this.moneyType = res?.data?.currency;
            resolve();
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    // 获取商品列表
    getProductList() {
      return new Promise((resolve, reject) => {
        try {
          window.utilV2.getData(window.ApiPath.pay_product_list, { currency: this.moneyType }, (data) => {
            this.rechargeList = data.product_data;
            let prodIndex = 0;
            if (this.difference < 0) {
              let index = this.rechargeList.findIndex((item) => +item.credit_num + this.difference >= 0);
              prodIndex = index > -1 ? index : this.rechargeList.length - 1;
            }
            this.currentSelectPayId = data.product_data[prodIndex].price_id;
            resolve();
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    // 支付金额
    payMoney() {
      utilV2.postData(
        ApiPath.pay_payment_links,
        // return_url: window.location.href
        { price_id: this.currentSelectPayId },
        (data) => {
          let payLink = data.payment_link;
          this.$emit("order", data.order_id, String(this.currentSelectPayNum));
          window.open(payLink);
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.recharge-content {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .recharge-item {
    width: 108px;
    height: 66px;
    background: #fafafb;
    border-radius: 8px;
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .diamonds {
      display: flex;
      color: #2c2f46 !important;
      font-weight: 700;
      font-size: 20px;
      font-family: "SF Pro";
      align-items: center;
      .icon-diamonds {
        margin-top: 5px;
        margin-right: 5px;
      }
    }
    .money {
      color: #2c2f46;
      font-family: "Inter";
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
      margin-top: 8px;
    }
  }
  .active {
    border: 3px solid #faae56;
    box-sizing: border-box;
  }
}
.btn-list {
  display: flex;
  margin-top: 44px;
  .btn-exam {
    height: 44px;
    width: 100%;
    border-radius: 8px;
    font-size: 18px;
    font-family: "Inter";
  }
  .btn-blue {
    background: #3bb590;
  }
}
</style>
